import { render, staticRenderFns } from "./BlogDetailsPage.vue?vue&type=template&id=180da33e&scoped=true"
import script from "./BlogDetailsPage.vue?vue&type=script&lang=js"
export * from "./BlogDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailsPage.vue?vue&type=style&index=0&id=180da33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180da33e",
  null
  
)

export default component.exports